import { Routes } from "@angular/router";

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { FULL_ROUTES } from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";
import {
  LOGIN_PATH,
  PASSWORD_CHANGE,
  PASSWORD_RECOVERY,
  PASSWORD_RESET_CHANGE,
} from "@sdk/lib/values/shared-paths";

import { CanSeeLogInPageGuard } from "./guards/can-see-log-in-page.guard";
import { HasChangedPasswordGuard } from "./guards/has-changed-password.guard";
import { HasPatientRoleAccessGuard } from "./guards/has-patient-role-access-guard";
import { IsUserIdleTimerStopForLoginPageGuard } from "./guards/is-user-idle-start-and-stop-timer.guard";

import { NotDeactivatedUserGuard } from "./guards/not-deactivated-user.guard";
import { AuthGuard } from "@auth0/auth0-angular";
import { IsDeactivatedUserGuard } from "./guards/is-deactivated-user.guard";

export const APP_ROUTES: Routes = [
  {
    path: "",
    redirectTo: LOGIN_PATH,
    pathMatch: "full",
    title: "pageTitle.dashboard",
  },
  {
    path: LOGIN_PATH,
    canActivate: [CanSeeLogInPageGuard],
    loadComponent: () =>
      import("./login/login-page/login-page.component").then((m) => m.LoginPageComponent),
    title: "pageTitle.login",
  },
  {
    path: PASSWORD_RECOVERY,
    loadComponent: () =>
      import("./recover-password/recover-password-page/recover-password-page.component").then(
        (m) => m.RecoverPasswordPageComponent,
      ),
    title: "pageTitle.passwordRecovery",
  },
  {
    path: PASSWORD_CHANGE,
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./change-password/change-password-page/change-password-page.component").then(
        (m) => m.ChangePasswordPageComponent,
      ),
    title: "pageTitle.changePassword",
  },
  {
    path: PASSWORD_RESET_CHANGE,
    redirectTo: LOGIN_PATH,
  },
  {
    path: "",
    component: FullLayoutComponent,
    children: FULL_ROUTES,
    canActivate: [
      HasChangedPasswordGuard,
      HasPatientRoleAccessGuard,
      IsUserIdleTimerStopForLoginPageGuard,
      NotDeactivatedUserGuard,
    ],
  },
  {
    path: "",
    component: ContentLayoutComponent,
    children: CONTENT_ROUTES,
    canActivate: [
      HasChangedPasswordGuard,
      HasPatientRoleAccessGuard,
      IsUserIdleTimerStopForLoginPageGuard,
      NotDeactivatedUserGuard,
    ],
  },
  {
    path: "deactivated",
    loadComponent: () =>
      import("./pages/content-pages/deactivated/deactivated-page.component").then(
        (m) => m.DeactivatedPageComponent,
      ),
    canActivate: [IsDeactivatedUserGuard],
    title: "pageTitle.accountDeactivated",
  },
  {
    path: "callback",
    loadComponent: () =>
      import("@uplift-sdk/lib/components/auth0-callback/auth0-callback.component").then(
        (m) => m.Auth0CallbackComponent,
      ),
    title: "pageTitle.loggingIn",
  },
  {
    path: "**",
    pathMatch: "full",
    loadComponent: () =>
      import("./pages/content-pages/error/error-page.component").then(
        (m) => m.ErrorPageComponent,
      ),
    title: "pageTitle.pageNotFound",
  },
];
